import emailjs from '@emailjs/browser';
import React, { useEffect } from 'react';
import { getUtmParams } from './utils/utm';
import { BrowserRouter } from "react-router-dom";
import WhatsAppWidget from "react-whatsapp-chat-widget";
import "react-whatsapp-chat-widget/index.css";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import "./App.css";
import Router from "./components/Router.jsx";
import ErrorBoundary from "./components/ErrorBoundary";
const Header = React.lazy(() => import('./components/Header'));
const Footer = React.lazy(() => import('./components/Footer'));

function WhatsAppSupport() {
  return (
    <WhatsAppWidget
      phoneNo="972525970820"
      position="right"
      widgetWidth="300px"
      widgetWidthMobile="260px"
      autoOpen={false}
      autoOpenTimer={10000}
      messageBox={true}
      messageBoxTxt="שלום, אני מעוניין/ת לקבל הצעת מחיר למשתנות ללא מים"
      iconSize="70"
      iconColor="white"
      iconBgColor="#00cda6"
      headerIconColor="pink"
      headerTxtColor="black"
      headerBgColor="#94ECBD"
      headerTitle="מוטי"
      headerCaption="מחובר"
      bodyBgColor="#FAFAFA"
      chatPersonName="שירות ותמיכה"
      chatMessage={<>👋 שלום <br /><br /> איך אוכל לעזור?</>}
      footerBgColor="#999"
      btnBgColor="#94ECBD"
      btnTxtColor="black"
      btnTxt="התחל שיחה"
    />
  );
}

function App() {
  useEffect(() => {
    getUtmParams();
  }, []);

  emailjs.init(import.meta.env.VITE_EMAILJS_PUBLIC_KEY);

  return (
    <div className="App">
        <BrowserRouter>
        <Header/>
      <ErrorBoundary>
        <Router/>
      </ErrorBoundary>
      <WhatsAppSupport />
      <Footer />
        </BrowserRouter>
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
